export default (isQuery = false) => {
	isQuery = window.location.href.includes("?");
	if(isQuery) return window.location.href.split("?")[0].split("/")[3];
	return window.location.href.split("/")[3];
}